import { Box, Typography } from "@mui/material";
import ScatterChart from "../../../components/common/ScatterChart";
import { csv } from "d3-fetch";
import { useState, useEffect } from "react";
import { curveNatural } from "@visx/curve";
import { makeTitleCase } from "../../../utils";
import { colors } from "../../../consts";

const demographics = ["black", "white", "hispanic"];

let demographic = demographics[0];
let hideXAxis = false;
let hideYAxis = false;
try {
  const params = new URLSearchParams(window.location.search);
  const demParam = params.get("dem");
  if (demParam) demographic = demParam;
  hideXAxis = typeof params.get("hideXAxis") === "string";
  hideYAxis = typeof params.get("hideYAxis") === "string";
} catch (error) {
  console.log("no window object available");
}
const color = colors.palette[demographics.indexOf(demographic)];

const parser = r => ({
  x: parseFloat(r[`pct${demographic}`]),
  y: parseFloat(r[`share.${demographic}`]),
  color,
  groupId: demographic,
  name: demographic,
});

const lineParser = r => ({
  x: parseFloat(r[`x.${demographic}`] / 100),
  y: parseFloat(r[`y.${demographic}`] / 100),
  color,
  groupId: demographic,
});

const VisContent = () => {
  const [data, setData] = useState(null);
  const [lineData, setLineData] = useState(null);
  useEffect(() => {
    csv("/data/blog/rural-figure.csv", parser).then(csvData => {
      setData([
        csvData.filter(({ x, y }) => !(Number.isNaN(x) || Number.isNaN(y))),
      ]);
    });
  }, []);

  useEffect(() => {
    csv("/data/blog/rural-fit.csv", lineParser).then(csvData =>
      setLineData([
        csvData.filter(({ x, y }) => !!x && !!y).sort((a, b) => a.x > b.x),
      ])
    );
  }, []);

  if (!data || !lineData) return null;

  let left = 80;
  let right = 40;

  // for the 3 side-by-side charts (xl breakpoint), keep total horiz margin for each chart at 86
  // with 58 *between* each (for equal width charts and spacing)
  if (hideXAxis && !hideYAxis) {
    // first chart
    left = 71;
    right = 15;
  } else if (!hideXAxis && hideYAxis) {
    // second chart
    left = 43;
    right = 43;
  } else if (hideXAxis && hideYAxis) {
    // third chart
    left = 15;
    right = 71;
  }
  return (
    <Box sx={{ width: "100%", height: "500px" }}>
      <ScatterChart
        curve={curveNatural}
        pointArrays={data}
        lineArrays={lineData}
        pointSize={4}
        yAxisLabel="Share of eviction filings"
        yAxisLabelOffset={46}
        xAxisLabel={!hideXAxis && `Share of county population`}
        xMin={0}
        xMax={1}
        showXEqYLine={true}
        margin={{ top: 39, left, right, bottom: 60 }}
        hideYAxis={hideYAxis}
        disableTooltip={true}
        lineOpacity={0.9}
        pointOpacity={0.25}
        showGrid={true}
        gridOptions={{
          numTicksRows: 4,
          numTicksColumns: 4,
        }}
      >
        <Typography
          sx={{
            position: "absolute",
            top: "0",
            width: "100%",
            textAlign: "center",
            // so that the label centers over the chart sans margin
            paddingLeft: `${left}px`,
            paddingRight: `${right}px`,
          }}
          className="visx-axis-label"
        >
          {makeTitleCase(demographic)}
        </Typography>
      </ScatterChart>
    </Box>
  );
};

export default VisContent;
